<template>

<!-- <q-btn v-if="isBtn && item.id" label="Photos" @click.stop="colis_state.openModalPhotos = true" />


<q-item v-if=" ! isBtn && item.id"
        clickable @click.stop="colis_state.openModalPhotos = true" v-close-popup>

    <q-item-section avatar><q-icon name="photo" /></q-item-section>

    <q-item-section>
        <q-item-label>Prendre des photos</q-item-label>
        <q-item-label caption v-if="count_photos">{{ pluralize(count_photos, 'photo') }} </q-item-label>
    </q-item-section>
</q-item> -->



<MyDialog v-if="colis_state.openModalPhotos && item.id"
        v-model="colis_state.openModalPhotos"
        persistent can-maximized
        :title="'Photos sur le colis - ref: '+ item.ref"
        @hide="closeModal()"
        @update:modelValue="closeModal()">

    <!-- <div v-if=" ! colisStore().delivered(item.status_current)" class="q-mb-md q-px-sm"> -->
    <div class="q-mb-md q-px-sm">

        <q-file v-model="form.file" label="Ajouter / Prendre une photo"
                ref="inputPhoto"
                accept="image/*"
                clearable
                @update:model-value="submit"
                :error="Boolean(form.errors.file)"
                :error-message="form.errors.file" no-error-icon
                :disable="colisStore().delivered(item.status_current)"
                hint="Colis Livré - Prises de photos désactivée" :hide-hint=" ! colisStore().delivered(item.status_current)">
                
            <template #append><q-icon name="add_a_photo" class="cursor-pointer" @click="inputPhoto?.pickFiles()" /></template>
        </q-file>

    </div>


    <div v-if="$_.size(item.files)">

        <Viewer :items="item.files" :dir="'/storage/colis-files/'+item.id+'/'" />

        <q-list dense separator>
            <q-separator />

            <q-item v-for="(filename, key) in item.files" :key="key">

                <q-item-section avatar>
                    <q-img :src="'/storage/colis-files/'+item.id+'/'+filename" :ratio="1" width="120px" />
                </q-item-section>
                <q-item-section></q-item-section>
                <q-item-section side>
                    <q-item-label caption>{{filename}}</q-item-label>
                </q-item-section>
                <q-item-section side>
                    <q-btn icon="delete_outline" color="negative" dense outline square size="sm"
                            @click="deletePhoto(filename)" />
                </q-item-section>
            </q-item>

        </q-list>
    </div>

    <MyAlert v-else dense>Aucune photo pour ce colis</MyAlert>

</MyDialog>

</template>

<script setup>
import { ref, computed/* , onMounted */ } from "@vue/runtime-core"
// import { pluralize /* pp, app_state, link, open */ } from "@helpers";

import Viewer from '@comp/partials/Viewer'

import { colisStore } from '@stores'

const props = defineProps({
    item: Object,
    // 'is-btn': Boolean,
})

const colis_state = colisStore().$state

let inputPhoto = ref(null)

let count_photos = computed(()=> _.size(props.item?.files))

let form = proto.$inertia.form({
    colis_id: props.item?.id,
    file: null,
})


const submit = () => {

    if(form.file){

        $q.loading.show({message: "Compression & Enregistrement en cours..."})

	    form.post(route("colis-store-photos"), {preserveScroll: true,/* forceFormData: true, */

            onSuccess:(res)=>{
                // log('in Colis Photos.vue - res',res)
                if(res.props?.result){

                    props.item.files = res.props.result

                    count_photos.value = _.size(res.props.result)

                    form.reset('file')

                    $q.loading.hide()
                }
            },
            onError:(err)=>{ $q.loading.hide() }
        });
    }
};

const deletePhoto = (filename)=>{

    $q.dialog({title:"Confirmation Suppression...",cancel:true,ok:{label:'Supprimer',color:'negative',outline:true, square: true}})
        .onOk(()=>{

            proto.$inertia.post(route("colis-delete-photo"),{
                    colis_id: props.item?.id,
                    filename: filename,
                },{preserveScroll: true,

                    onSuccess:(res)=>{
                        if(res.props?.result){
                            props.item.files = res.props.result
                        }
                    }
                })
    })
}

const closeModal = ()=>{

    colis_state.openModalPhotos = false
    colis_state.itemForPhotos = null
    form.reset()
}




</script>
